// Firmowe/Prywatne
export const realEstatesCorporatePrivate = (state = false, action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_CORPORATE_PRIVATE_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Hipoteka obciążona
export const realEstatesMortgageEncumbered = (state = false, action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_MORTGAGE_ENCUMBERED_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Własność
export const realEstatesOwnership = (state = false, action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_OWNERSHIP_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Zaległości podatkowe
export const realEstatesFiles = (state = [], action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Zaległości podatkowe itemy

export const realEstatesItems = (state = [], action) => { 
    switch (action.type) {
        case 'REAL_ESTATES_ITEMS_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Posiadane środki trwałe

export const fundsFiles = (state = [], action) => { 
    switch (action.type) {
        case 'FUNDS_FILES_CHANGE':
            return action.value;      
        default:
            return state
    }
}

// Posiadane środki trwałe itemy

export const fundsItems = (state = [], action) => { 
    switch (action.type) {
        case 'FUNDS_ITEMS_CHANGE':
            return action.value;      
        default:
            return state
    }
}